function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { useRequest, emptyArray } from '@applyboard/ui-utils';

/* This is the stored representation of a program so it can be
 * properly handled by the SelectProgramsModal and BackupProgramSelector
 * components.
 */

export var useBackupProgramCandidates = function useBackupProgramCandidates(_ref) {
  var studentId = _ref.studentId,
    schoolId = _ref.schoolId,
    schoolGroupId = _ref.schoolGroupId,
    intake = _ref.intake,
    excludeEslPrograms = _ref.excludeEslPrograms,
    searchText = _ref.searchText;
  var queryParams = [typeof schoolGroupId === 'undefined' ? "school_id=".concat(schoolId) : "school_group_id=".concat(schoolGroupId), // See https://applyboard.slack.com/archives/C02TFPWQNCV/p1650892690966909
  // and https://applyboard.slack.com/archives/C02TFPWQNCV/p1651001588448609
  "what_type=tag&what_value=*".concat(searchText, "*&what_text=*").concat(searchText, "*"), 'page[size]=101'];
  var _useRequest = useRequest("/program_search.json?".concat(queryParams.join('&')), {
      queryKey: ['backupProgramCandidates', {
        schoolGroupId: schoolGroupId,
        schoolId: schoolId,
        studentId: studentId,
        intake: intake,
        excludeEslPrograms: excludeEslPrograms,
        searchText: searchText,
        pkg: 'ab-application-legacy'
      }],
      method: 'POST',
      body: {
        intakes: {
          value: [intake]
        },
        student_id: studentId,
        exclude_esl_programs: excludeEslPrograms
      },
      // eslint-disable-next-line no-restricted-syntax -- TODO: Refactor this to use `schema`
      isExpectedResponse: function isExpectedResponse(r) {
        return _typeof(r) === 'object' && !!r;
      },
      throwOnErrorResponse: function throwOnErrorResponse() {
        throw new Error('An error occurred while trying to load backup programs');
      },
      preprocess: function preprocess() {
        if (!schoolGroupId && !schoolId) {
          return {};
        }
        return undefined;
      },
      postprocess: function postprocess(rawProgramOptions) {
        if (!rawProgramOptions || Object.keys(rawProgramOptions).length <= 0) {
          return [];
        }
        if (!Array.isArray(rawProgramOptions === null || rawProgramOptions === void 0 ? void 0 : rawProgramOptions.schools)) {
          return [];
        }
        var results = rawProgramOptions.schools.reduce(function (acc, school) {
          var schoolPrograms = school.programs || [];
          var formattedPrograms = schoolPrograms.map(function (program) {
            return {
              logo: '',
              programId: program.id,
              programName: program.name,
              schoolId: school.school_id,
              schoolName: school.school_name
            };
          });
          return acc.concat(formattedPrograms);
        }, []);
        return results;
      },
      // The programs don't change very often, so let's assume the data
      // is always fresh.  This prevents excessive re-fetching of data we
      // already have that is likely fresh anyway.  This API isn't optimized
      // either, and the backend developers responsible for this api are
      // concerned about performance
      // See: https://applyboard.slack.com/archives/C02TFPWQNCV/p1642620854043600
      staleTime: Infinity,
      keepPreviousData: true
    }),
    data = _useRequest.data,
    error = _useRequest.error,
    isLoading = _useRequest.isLoading;
  return {
    backupProgramCandidates: Array.isArray(data) ? data.slice(0, 100) : emptyArray,
    hasMoreBackupProgramCandidates: Array.isArray(data) && data.length > 100,
    backupProgramsError: error,
    isLoadingBackupProgramCandidates: isLoading
  };
};